import classNames from "classnames"
import { ReactCountryFlag } from "react-country-flag"
import { useTranslation } from "react-i18next"
import { countryCodeToName } from "@oysterhr/common"
import type { CountryIsoCode } from "@oysterhr/schema"

const SIZES_CONFIG = {
  xs: {
    flag: {
      height: "0.75rem",
      width: "1.125rem",
    },
    text: "text-xs",
  },
  sm: {
    flag: {
      height: "1rem",
      width: "1.5rem",
    },
    text: "text-sm",
  },
  md: {
    flag: {
      height: "1.16rem",
      width: "1.75rem",
    },
    text: "text-base",
  },
}

export const CountryTag = ({
  size = "md",
  countryCode,
  className,
  classNameFlag,
}: {
  size?: "xs" | "md" | "sm"
  countryCode?: CountryIsoCode | null
  className?: string
  classNameFlag?: string
}) => {
  const { t } = useTranslation("hiring_templates/Common")

  return countryCode ? (
    <div className={classNames(SIZES_CONFIG[size].text, className)}>
      <ReactCountryFlag
        countryCode={countryCode as string}
        svg
        className={classNames("inline-block h-4 w-4 rounded-sm object-cover shadow", classNameFlag)}
        style={SIZES_CONFIG[size].flag}
      />
      <span className="ml-2">{countryCodeToName(countryCode)}</span>
    </div>
  ) : (
    <div className={classNames(SIZES_CONFIG[size].text, className)}>
      <span>🌎</span>
      <span className="ml-2">{t("theWorld")}</span>
    </div>
  )
}
